/* eslint-disable import/prefer-default-export */
import http from './http';

/**
 * Auth routes
 */
const authLogin = (payload) => {
  return http.post('auth/login', payload);
};
const forgotPassword = (payload) => {
  return http.post('auth/forgot-password', payload);
}
const resetPassword = (payload) => {
  return http.post('auth/reset-password', payload);
}

/**
 * Me routes
 */
const getProfile = () => {
  return http.get('account');
}
const logout = () => {
  return http.post('auth/logout');
}

/**
 * User routes
 */
const userGetList = () => {
  return http.get('user');
}
const userCreate = (payload) => {
  return http.post('user', payload);
}
const userGetDetail = (user_id) => {
  return http.get(`user/${user_id}`);
}
const userUpdate = (user_id, payload) => {
  return http.put(`user/${user_id}`, payload);
}

/**
 * Emotion routes
 */
const emotionGetNewest = () => {
  return http.get('/emotion/newest');
}

const emotionGetDetails = (user_id) => {
 return http.get(`emotion/${user_id}`);
};

/**
 * Department
 */
const departmentGetList = () => {
  return http.get('department');
};

/**
 * Positon
 */
const positionGetList = () => {
  return http.get('position');
};

/**
 * Positon
 */
const newUI = () => {
  return http.get('newUI');
};

export {
  authLogin,
  forgotPassword,
  resetPassword,
  logout,
  getProfile,
  userGetList,
  userCreate,
  userGetDetail,
  userUpdate,
  emotionGetNewest,
  emotionGetDetails,
  departmentGetList,
  positionGetList,
  newUI,
}